import React, { useState, useEffect } from 'react';
import { ApplicationInterface } from "../interfaces";
import CustomButton from "../../../components/CustomButton";
import AlertIcon from "../../../components/Icons/AlertIcon";
import Api from "../../../services/Api";
import {scrollTop} from "../../../helpers/scrolling";

interface Props {
    application: ApplicationInterface;
    save: Function
}


const StepTwo: React.FC<Props> = (props: Props) => {
    const api = Api.getInstance()
    const [certificateFile, setCertificateFile] = useState<string>(props.application.certificateFile);
    const [yearOfCertification, setYearOfCertification] = useState<number>(props.application.yearOfCertification);
    const [coachingHours, setCoachingHours] = useState<string>(props.application.coachingHours + "");
    const [errors, setErrors] = useState<number>(0)
    const [errorFields, setErrorFields] = useState<Array<string>>(["", "", ""])
    const [triedSave, setTriedSave] = useState<boolean>(false)

    const now = new Date()
    const thisYear = now.getFullYear()

    useEffect(() => {
        scrollTop()
    }, [])

    useEffect(() => {
        if (triedSave) {
            checkInput()
        }
    }, [certificateFile, yearOfCertification, coachingHours])

    const checkInput = () => {
        let _errors = 0
        const _errorFields = ["", "", "", "", "", ""]
        if (!certificateFile) {
            _errors++
            _errorFields[0] = "Please upload a certificate"
        }
        if (yearOfCertification === 0) {
            _errors++
            _errorFields[1] = "Please select the year of certification"
        } else if (yearOfCertification < 2022) {
            _errors++
            _errorFields[1] = "Your certificate shouldn't be older than three years, please renew it"
        }
        const _coachingHours = parseInt(coachingHours)
        if (isNaN(_coachingHours)) {
            _errors++
            _errorFields[2] = "Please enter a valid number"
        } else if (_coachingHours < 200) {
            _errors++
            _errorFields[2] = "You need to have at least 200 coaching hours to register with Zebrain"
        }
        setErrors(_errors)
        setErrorFields(_errorFields)
        return _errors
    }

    const changeYear = (year: string)=> {
        setYearOfCertification(parseInt(year))
    }

    const changeCoachingHours = (hours: string)=> {
        setCoachingHours(hours)
    }

    const save = () => {
        setTriedSave(true)
        if (checkInput() > 0) {
            console.log('There are errors')
            return
        }
        const _application: ApplicationInterface = props.application
        _application.certificateFile = certificateFile
        _application.yearOfCertification = yearOfCertification
        _application.coachingHours = parseInt(coachingHours)
        props.save(_application)
    }

    const uploadFile = (evt: any) => {
        if (evt === null) {
            alert('Empty event');
            return;
        }

        const file = evt.target.files[0];
        if (!file) {
            console.log('No file')
            return
        }

        const reader = new FileReader();


        reader.onload = ((theFile) => {
            return (e: any) => {
                const data = {
                    file_data: e.target.result,
                    file_name: file.name
                }
                api.post('coach/upload/certificate', data).then(result => {
                    setCertificateFile(result.json.fileName)
                })
            };
        })(file);

        reader.readAsDataURL(file);
    }

    const showUploadedFile = () => {
        if (!certificateFile) {
            return ""
        }
        const fParts = certificateFile.split('/')
        return fParts[fParts.length - 1]
    }

    return (
      <>
          <div className="mt-6 text-xl font-medium">Certification</div>

          <div className="mt-6 flex items-center justify-between">
              <input id="certFile" type="file" className="hidden" onChange={(e: any) => uploadFile(e)}/>
              <div>
                  <p>Certificate</p>

              </div>
              <label htmlFor="certFile">
                  <div className="bg-neutral-700 rounded-full py-3 px-4 cursor-pointer">
                      {
                          certificateFile ? 'Change' : 'Upload'
                      }
                  </div>
              </label>
          </div>
          {
              certificateFile &&
            <div className="text-sm font-medium text-neutral-400">
                <a target="_new" href={certificateFile}>{showUploadedFile()}</a> has been uploaded
            </div>
          }
          {
            errorFields[0].length > 0 &&
              <div className="mt-2 text-cherry-500">
                  {errorFields[0]}
              </div>
          }

          <div className="mt-6">Year of certification</div>
          <select value={yearOfCertification + ""}
                  onChange={(e) => changeYear(e.target.value)}
                  className={"z-select mt-2" + (triedSave && errorFields[1] ? " error" : "")}>
          <option value={0}>Select year</option>
              <option value={thisYear}>{thisYear}</option>
              <option value={thisYear - 1}>{thisYear - 1}</option>
              <option value={thisYear - 2}>{thisYear - 2}</option>
              <option value={thisYear - 3}>{thisYear - 3}</option>
              <option value={thisYear - 4}>Before {thisYear - 3}</option>
          </select>
          {
            errorFields[1].length > 0 &&
              <div className="mt-2 text-cherry-500">
                  {errorFields[1]}
              </div>
          }

          <div className="mt-6">Total coaching hours</div>
          <input value={coachingHours} placeholder="Coaching hours"
                 className={"z-input mt-2" + (triedSave && errorFields[2] ? " error" : "")}
                 onChange={(e) => changeCoachingHours(e.target.value)}/>

          {
              errorFields[2].length > 0 &&
                <div className="mt-2 text-cherry-500">
                    {errorFields[2]}
                </div>
          }

          {
            (triedSave && errors > 0) &&
              <div className="mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center">
                  <AlertIcon aria-label="Error" className="text-cherry-500!"/>
                  <div className="ml-2 font-medium">Please make sure all fields are filled out correctly</div>
              </div>
          }


          <CustomButton className="mt-6" onClick={() => save()}>
              Next
          </CustomButton>
      </>
    )
}

export default StepTwo